import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/products/sinhroperevod/webp/sinhroperevod.webp")